import { useState, useLayoutEffect } from "react";
import { useMediaQuery } from "./use-media-query";

export function useBreakpoints() {
  const [isClient, setIsClient] = useState(false);

  const breakpoints = {
    isXs: useMediaQuery("(max-width: 640px)"),
    isSm: useMediaQuery("(min-width: 641px) and (max-width: 743px)"),
    isMd: useMediaQuery("(min-width: 744px) and (max-width: 1119px)"),
    isLg: useMediaQuery("(min-width: 1120px)"),
    active: "SSR",
  };

  useLayoutEffect(() => {
    if (typeof window !== "undefined") setIsClient(true);
  }, []);

  if (isClient && breakpoints.isXs) breakpoints.active = "xs";
  if (isClient && breakpoints.isSm) breakpoints.active = "sm";
  if (isClient && breakpoints.isMd) breakpoints.active = "md";
  if (isClient && breakpoints.isLg) breakpoints.active = "lg";

  return breakpoints;
}

// useBreakpoints usage

// const Test = () => {
//     const { isXs, isSm, isMd, isLg, active } = useBreakpoints();
//   };

//   // -------------------------
//   // useMediaQuery usage

//   const Test = () => {
//     let isPageWide = useMediaQuery("(min-width: 800px)");
//   };
